// 导出页面为PDF格式
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import white from "../images/download_white.jpg";
import orange from "../images/download_orange.jpg";
import red from "../images/download_red.jpg";
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function(type) {
      var title = "配置清单";
      html2Canvas(document.querySelector("#pdfDom"), {
        allowTaint: true,
        scale: 2
      }).then(function(canvas) {
        // var img = "../images/test.png"; //imgurl 就是你的图片路径
        var img = "";
        console.log(type);
        switch (type) {
          case 0:
            img = white;
            break;
          case 1:
            img = orange;
            break;
          case 2:
            img = red;
            break;
          default:
            break;
        }
        function getBase64Image(img) {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, img.width, img.height);
          var ext = img.src
            .substring(img.src.lastIndexOf(".") + 1)
            .toLowerCase();
          var dataURL = canvas.toDataURL("image/" + ext);
          console.log(dataURL);
          return dataURL;
        }

        var image = new Image();
        image.src = img;
        image.onload = function() {
          var base64 = getBase64Image(image);

          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 592.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(base64, "JPEG", 16, 16, 560, 386);
            PDF.addImage(pageData, "JPEG", 0, 400, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(title + ".pdf");
        };
      });
    };
  }
};
